module.exports = "/static/assets/8c3127887a7aacaea989aa247e510f84.jpg";